import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import CustomModal from "../../../ui/CustomModal/CustomModal";
import CustomTextInput from "../../../ui/CustomTextInput/CustomTextInput";
import CustomButton from "../../../ui/CustomButton/CustomButton";

export default function GenerateApiKeyModal({
  opened,
  onClose,
  control,
  onSubmit,
  isSubmitting,
  isSubmitDisabled,
}) {
  return (
    <CustomModal
      opened={opened}
      onClose={onClose}
      title={
        <span className="text-base font-semibold text-gray-900">
          Generate API Key
        </span>
      }
      centered
      radius="lg"
      overlayProps={{ backgroundOpacity: 0.55, blur: 3 }}
      withCloseButton={!isSubmitting}
      closeOnClickOutside={!isSubmitting}
      closeOnEscape={!isSubmitting}
      styles={{ body: { padding: "0px 24px 24px" } }}
    >
      <Controller
        name="credentialName"
        control={control}
        rules={{
          required: "Credential name is required",
          maxLength: {
            value: 100,
            message: "Credential name must not exceed 100 characters",
          },
          validate: (v) => !!v.trim() || "Credential name is required",
        }}
        render={({ field, fieldState }) => (
          <CustomTextInput
            {...field}
            label="Credential Name"
            description="A label to help you identify these API credentials"
            placeholder="Production App"
            radius="md"
            error={fieldState.error?.message}
            maxLength={100}
            disabled={isSubmitting}
          />
        )}
      />
      <div className="mt-4 flex items-center justify-end gap-2">
        <CustomButton
          variant="default"
          color="error"
          onClick={onClose}
          disabled={isSubmitting}
        >
          Cancel
        </CustomButton>
        <CustomButton
          color="dark"
          loading={isSubmitting}
          disabled={isSubmitDisabled}
          onClick={onSubmit}
        >
          Create
        </CustomButton>
      </div>
    </CustomModal>
  );
}

GenerateApiKeyModal.propTypes = {
  opened: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  control: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isSubmitDisabled: PropTypes.bool.isRequired,
};
